import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { DocumentEditorType, IoniconsFilled, UiWidget, WidgetNotification } from '@pt/pt-models';
import * as NgrxWidgetActions from '../store/actions/widget.actions';
import { WidgetUtils } from '../widgets/widget.utils';
import { Chapter } from 'it/primatoo/openapi/api/org/schemas/common/docs/_listtemplatechapterresponse/Chapter';
import { Widget } from 'it/primatoo/openapi/api/org/schemas/common/docs/Widget';

@Component({
  selector: 'pt-widget-notification',
  template: `
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">
        {{ title }}
        <p
          [innerText]="'WIDGET_NOTIFICATION.OPEN_ERROR_V2' | translate"
          *ngIf="dialogNotification.size > 0"
          class="mb-0"
          style="font-size: 14px"
        ></p>
      </h4>

      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="closeWithoutSaveDialog()"
      ></button>
      <!--      <button type='button' class='btn-close' aria-label='Close' (click)='closeWithoutSaveDialog()'>-->
      <!--        <span aria-hidden='true'>&times;</span>-->
      <!--      </button>-->
    </div>

    <div
      class="modal-body modal-body--custom"
      *ngIf="dialogNotification.size > 0"
    >
      <div>
        <!--        <div>-->
        <!--          <p [innerText]="'WIDGET_NOTIFICATION.OPEN_ERROR' | translate"></p>-->
        <!--          <ul>-->
        <!--            <li>-->
        <!--              <pt-icon [key]='"information-circle"' class='text-primary' [size]='20'></pt-icon>-->
        <!--              {{'WIDGET_NOTIFICATION.OPEN_ERROR_INFO' | translate}}-->
        <!--            </li>-->
        <!--            <li>-->
        <!--              <pt-icon [key]='"warning"' class='text-warning' [size]='20'></pt-icon>-->
        <!--              {{'WIDGET_NOTIFICATION.OPEN_ERROR_WARNING' | translate}}-->
        <!--            </li>-->
        <!--          </ul>-->
        <!--        </div>-->
        <table class="table table-striped table-sm">
          <thead>
            <tr>
              <th scope="col">{{ 'LABELS.SECTION' | translate }}</th>
              <th scope="col">{{ 'LABELS.DETAILS' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let groupLabel of groupLabels">
              <td>{{ groupLabel }}</td>
              <td>
                <div
                  class="me-2 mb-1"
                  *ngFor="let n of dialogNotification.get(groupLabel)"
                >
                  <ng-container
                    *ngIf="
                      n.action === 'show-and-save' ||
                      n.action === 'show-and-reopen'
                    "
                  >
                    <p class="mb-0">
                      <pt-icon
                        container="body"
                        ngbTooltip="{{
                          'WIDGET_NOTIFICATION.OPEN_ERROR_WARNING_V2'
                            | translate
                        }}"
                        [key]="IconWarning"
                        class="text-warning"
                        [size]="20"
                      ></pt-icon>
                      {{ n?.widget.label }}
                    </p>
                    <p class="fw-bold" style="font-size: 11px">
                      {{ n?.message | async }}
                    </p>
                  </ng-container>

                  <ng-container *ngIf="n.action === 'show'">
                    <p class="mb-0">
                      <pt-icon
                        container="body"
                        ngbTooltip="{{
                          'WIDGET_NOTIFICATION.OPEN_ERROR_INFO_V2' | translate
                        }}"
                        [key]="'information-circle'"
                        class="text-primary"
                        [size]="20"
                      >
                      </pt-icon>
                      {{
                        'WIDGET_NOTIFICATION.INVALID_QUERY_RESPONSE.NO_DATA_FOR_QUESTION'
                          | translate
                      }}
                      <b>{{ n?.widget.label }}</b>
                    </p>
                  </ng-container>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal-footer" *ngIf="!showSaveButton && !showReopenButton">
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm"
        (click)="closeWithoutSaveDialog()"
      >
        {{ 'BUTTON.CLOSE' | translate }}
      </button>
    </div>

    <div class="modal-footer" *ngIf="showSaveButton">
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm"
        (click)="closeWithoutSaveDialog()"
      >
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-outline-dark btn-sm"
        (click)="closeWithConfirmDialog()"
      >
        {{ 'BUTTON.PROCEED' | translate }}
      </button>
    </div>

    <div class="modal-footer" *ngIf="showReopenButton">
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm"
        (click)="closeWithoutSaveDialog()"
      >
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-outline-dark btn-sm"
        (click)="closeWithReopenDialog()"
      >
        {{ 'BUTTON.REOPEN_PROCESS' | translate }}
      </button>
    </div>
  `,
  styles: [
    `
      .modal-body--custom {
        max-height: 500px;
        overflow-y: auto;
      }

      .modal-body--custom::-webkit-scrollbar {
        width: 5px;
        height: 5px;
      }

      .modal-body--custom::-webkit-scrollbar-thumb {
        background: var(--bs-primary);
        border-radius: 0px;
      }

      .modal-body--custom::-webkit-scrollbar-thumb:hover {
        background: var(--bs-secondary);
      }

      .modal-body--custom::-webkit-scrollbar-track {
        background: #f0f0f0;
        border-radius: 0px;
        box-shadow: inset 0px 0px 0px 0px #f0f0f0;
      }

      .notification-label {
        font-weight: bold;
        margin-bottom: 2px;
      }

      .notification-message {
        font-size: 12px;
        margin: 0;
      }

      .notification-message ul {
        padding-left: 20px;
      }
    `,
  ],
})
export class WidgetNotificationComponent implements OnDestroy, OnChanges {
  @Input() activeChapter: Chapter;
  @Input() title: string;

  @Input() notifications: WidgetNotification[];

  @Output() closeDialog = new EventEmitter();
  IconWarning = IoniconsFilled.warning;
  IconInfo = IoniconsFilled.infoCircle;
  dialogNotification: Map<string, WidgetNotification[]>;
  groupLabels: Array<string>;
  showSaveButton: boolean;
  showReopenButton: boolean;
  private destroy$: Subject<boolean> = new Subject();

  constructor(private store: Store) {}

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  closeWithoutSaveDialog() {
    this.store.dispatch(NgrxWidgetActions.clearWidgetNotifications());
    this.closeDialog.emit();
  }

  closeWithConfirmDialog() {
    this.store.dispatch(NgrxWidgetActions.clearWidgetNotifications());

    const saveWidget = this.notifications?.filter(
      (notification) => notification.action === 'show-and-save'
    );
    if (saveWidget?.length > 0) {
      const request: Widget[] = saveWidget.map((w) =>
        WidgetUtils.toWidgetRequest(
          w.payload as UiWidget,
          this.activeChapter?.selector
        )
      );
      console.log('1 save widget ', request);
      this.store.dispatch(
        NgrxWidgetActions.saveWidgets({
          widgets: request,
          initialization: false,
        })
      );
    }

    this.closeDialog.emit();
  }

  closeWithReopenDialog() {
    this.store.dispatch(NgrxWidgetActions.clearWidgetNotifications());

    const reopenDocument = this.notifications?.filter(
      (notification: WidgetNotification) =>
        notification.action === 'show-and-reopen'
    );
    reopenDocument.forEach((w: WidgetNotification) => {
      const docInfo: { docId: number; docType: DocumentEditorType } =
        w.payload as {
          docId: number;
          docType: DocumentEditorType;
        };
      this.store.dispatch(
        NgrxWidgetActions.reopenDocument({
          id: docInfo.docId,
          docType: docInfo.docType,
        })
      );
    });

    this.closeDialog.emit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.notifications) {
      this.showSaveButton = false;
      this.showReopenButton = false;
      this.dialogNotification = new Map<string, WidgetNotification[]>();
      this.groupLabels = [];
      this.notifications?.forEach((n: WidgetNotification) => {
        this.showSaveButton = n.action === 'show-and-save';
        this.showReopenButton = n.action === 'show-and-reopen';
        if (this.dialogNotification.has(n.groupLabel)) {
          this.dialogNotification.get(n.groupLabel).push(n);
        } else {
          this.groupLabels.push(n.groupLabel);
          this.dialogNotification.set(n.groupLabel, [n]);
        }
      });

      // TEST
      // this.notifications?.forEach((n: WidgetNotification) => {
      //   const copy = JSON.parse(JSON.stringify(n)) as WidgetNotification;
      //   copy.action = 'show';
      //   if (this.dialogNotification.has(copy.groupLabel)) {
      //     this.dialogNotification.get(copy.groupLabel).push(copy);
      //   } else {
      //     this.dialogNotification.set(copy.groupLabel, [copy]);
      //   }
      // });
    }
  }
}
